export default {
  settings: {
    languageId: 'en',
  },
  labels: {
    en: {
      // Schedule status
      'schedule.status.success': 'Done',
      'schedule.status.failed': 'Error',
      'schedule.status.inProgress': 'In Progress',
      'schedule.status.notStarted': 'Not Started',
      'schedule.failed.message':
        'We encountered an issue preparing your feed and we are working to resolve the issue. If this issue persists, contact support.',
    },
  },
}
